import {ClaimEnums} from '../enums'

const authMixin = {

    // todo: refactor this!
    data(){
        return {
            claimEnums: ClaimEnums
        }
    },

    methods:{
        hasClaims(userRole, claim){
            if(userRole == null){
                return false;
            }
            let claimId = typeof claim === 'string' ? this.claimEnums[claim] : claim;
            //console.info('claimId', claimId)
            //console.info('userRole.Claims.find(x => x.ClaimId === claimId)', userRole.Claims.find(x => x.ClaimId === claimId) !== undefined)
            return userRole.Claims.find(x => x.ClaimId === claimId) !== undefined;
        },

        hasClaimsOrAdmin(user, claim) {
            if (user == null) {
                return false;
            } 
            if (user.MainRole === 'administrators') {
                return true;
            }
            if (user.DynamicRole == null) {
                return false;
            }
            let claimId = typeof claim === 'string' ? this.claimEnums[claim] : claim;
            //console.info('claimId', claimId)
            //console.info('userRole.Claims.find(x => x.ClaimId === claimId)', userRole.Claims.find(x => x.ClaimId === claimId) !== undefined)
            return user.DynamicRole.Claims.find(x => x.ClaimId === claimId) !== undefined;
        },

        callApiWrapper(promise){
            let vm = this;
            return promise.then((resp) => {
                if(resp.hasError){

                    if(resp.status === 401) {
                        const loginUrlWithUTM = this.getLoginUrlWithUTM();
                        vm.$router.push(loginUrlWithUTM);
                        return {
                            data: null,
                            status: 401,
                            hasError: true
                        };
                    }

                }

                return resp;
            });
        },

         // Функция для формирования URL с UTM-параметрами
        getLoginUrlWithUTM() {
            const urlParams = new URLSearchParams(window.location.search);
            const utmSource = urlParams.get('utm_source');
            const utmMedium = urlParams.get('utm_medium');
            const utmCampaign = urlParams.get('utm_campaign');

            // Базовый путь страницы логина
            let loginUrl = '/login';

            // Добавляем UTM-параметры, если они есть
            if (utmSource || utmMedium || utmCampaign) {
                loginUrl += '?';
                if (utmSource) loginUrl += `utm_source=${utmSource}&`;
                if (utmMedium) loginUrl += `utm_medium=${utmMedium}&`;
                if (utmCampaign) loginUrl += `utm_campaign=${utmCampaign}`;
                loginUrl = loginUrl.replace(/&$/, ''); // Убираем лишний символ '&' в конце
            }

            return loginUrl;
        }
    }
};

export default authMixin;


// WEBPACK FOOTER //
// ./Content/src/helpers/auth-mixin.js